var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg6DoticonGreyedOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.098,
    height: 10,
    viewBox: "0 0 6.098 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_29629",
    "data-name": "Path 29629",
    d: "M5.473,4.57a1.1,1.1,0,1,0-1.1-1.1A1.1,1.1,0,0,0,5.473,4.57Zm3.9,0a1.1,1.1,0,1,0-1.1-1.1A1.1,1.1,0,0,0,9.375,4.57Zm1.1,2.8a1.1,1.1,0,1,1-1.1-1.1A1.1,1.1,0,0,1,10.473,7.375Zm-5,1.1a1.1,1.1,0,1,0-1.1-1.1A1.1,1.1,0,0,0,5.473,8.473Zm5,2.8a1.1,1.1,0,1,1-1.1-1.1A1.1,1.1,0,0,1,10.473,11.277Zm-5,1.1a1.1,1.1,0,1,0-1.1-1.1A1.1,1.1,0,0,0,5.473,12.375Z",
    transform: "translate(-4.375 -2.375)",
    fill: "#A9AAAC",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6DoticonGreyedOut);
export default __webpack_public_path__ + "static/media/6doticonGreyedOut.3866eb69dcc983b4bafeb1da2337dea0.svg";
export { ForwardRef as ReactComponent };